import { FAIconName, Icon, Text } from "@/ui/core";
import type { AvatarCardProps } from "@/ui/core";
import AvatarCard from "@/ui/core/AvatarCard";
import { BaseCard, Box, HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface AppointmentAvatarCardProps extends AvatarCardProps {
  infoLabel?: string;
  isAppUser?: boolean;
  isDisabled?: boolean;
  isSelected?: boolean;
  onSelect?: (userId: string) => void;
}

const AppointmentAvatarCard = ({
  infoLabel,
  isAppUser,
  isDisabled,
  isSelected,
  onSelect,
  pronouns,
  subtitle,
  userId,
  userName,
  userType,
}: AppointmentAvatarCardProps) => {
  const baseTestID = joinTestIDs(userId, "provider-avatar");

  const infoLabelColor = isSelected
    ? ColorToken.Primary100
    : ColorToken.NeutralSecondary;

  const subtitleValue = isAppUser ? "You" : subtitle;

  return (
    <BaseCard
      isDisabled={isDisabled}
      isSelected={isSelected}
      onPress={() => onSelect?.(userId)}
      testID={baseTestID}
    >
      <VStack gap={10}>
        <HStack>
          <Box flexGrow={1}>
            <AvatarCard
              pronouns={pronouns}
              subtitle={subtitleValue}
              userId={userId}
              userName={userName}
              userType={userType}
            />
          </Box>
          {isSelected && (
            <Icon
              accessibilityLabel={`${userName} selected`}
              color={ColorToken.Primary100}
              name={FAIconName.Check}
              size="sm"
              testID={joinTestIDs(baseTestID, "selected")}
            />
          )}
        </HStack>

        {infoLabel && (
          <HStack gap={4}>
            <Icon
              color={infoLabelColor}
              name={FAIconName.InfoCircle}
              size="sm"
              testID={joinTestIDs(baseTestID, "info")}
            />
            <Box flex={1}>
              <Text
                color={infoLabelColor}
                testID={joinTestIDs(baseTestID, "info-label")}
                variant="caption"
              >
                {infoLabel}
              </Text>
            </Box>
          </HStack>
        )}
      </VStack>
    </BaseCard>
  );
};

export type { AppointmentAvatarCardProps };
export default AppointmentAvatarCard;
